import SearchIcon from '@mui/icons-material/Search';
import { Box, Grid, InputBase, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState, useEffect } from 'react';
import { IWorkAssignmentsDTOWrapper, closeWorkAssignments, ITeam } from 'wisestep-api';

import NoDataFoundCard from '../../../../../../components/noDataFoundCard';
import { failed, success } from '../../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../../utils/NotificationStore';
import { getWorkAssignments } from '../../../../../jobs/helper';
import TeamsCard from '../../teamsCard/TeamsCard';

interface teamsProps {
  jobId: string;
}

const assignmentsObject: IWorkAssignmentsDTOWrapper = {
  assignedByRecruiterId: '',
  workAssignmentDTOList: [],
  recruiterDTOList: [],
  jobDTOList: [],
  teamDTOList: [],
  vendorPartnerDTOList: [],
};

const Teams = ({ jobId }: teamsProps) => {
  const [refresh, setRefresh] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [workAssignmentsOfTeams, setWorkAssignmentsOfTeams] = useState<ITeam[]>([]);
  const [teams, setTeams] = useState<ITeam[]>([]);

  const unAssignTeam = async (teamId) => {
    const assignments = assignmentsObject;
    try {
      if (jobId) {
        assignments.jobDTOList.push(jobId);
        assignments.teamDTOList.push(teamId);
        await closeWorkAssignments(assignments);
        setRefresh(!refresh);
        setNotification(success('Unassigned to the team'));
      }
    } catch (e) {
      setNotification(failed('Something went wrong, Please try again !!'));
    }
  };

  useEffect(() => {
    const getAssignments = async () => {
      const assignments = await getWorkAssignments(jobId);
      setWorkAssignmentsOfTeams(assignments.teams);
      setTeams(assignments.teams);
    };
    getAssignments();
  }, [jobId, refresh]);

  const onTeamsInput = (event) => {
    if (!isEmpty(event.target.value)) {
      const filteredRows =
        workAssignmentsOfTeams?.filter((team) => {
          return team.name?.toLowerCase().includes(event.target.value.toLowerCase());
        }) ?? [];
      setTeams(filteredRows);
    } else {
      setTeams(workAssignmentsOfTeams);
    }
  };
  return (
    <>
      {!isEmpty(teams) ? (
        <Box>
          <Stack direction="row" spacing={1} alignItems="center">
            <SearchIcon />
            <InputBase placeholder="search" onChange={onTeamsInput} fullWidth />
          </Stack>
          <Grid xs={12} container justifyContent="space-between" spacing={2} my={1}>
            {teams.map((item, index) => {
              return (
                <Grid item xs={6} key={index}>
                  {item?.name && (
                    <TeamsCard title={item?.name} onclick={() => unAssignTeam(item.id)} />
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Box>
      ) : (
        <NoDataFoundCard text="Job not yet assigned to Team(s)" />
      )}
    </>
  );
};

export default Teams;
